import Vue from 'vue'
import App from './App.vue'
import {router} from './router'
import store from './store'

Vue.config.productionTip = false

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.baseURL = process.env.VUE_APP_API + "/api/v1/";

window.axios.interceptors.request.use(function(config) {
	let token = JSON.parse(localStorage.getItem("token"));

	if ( !!token ) {
		config.headers.Authorization = `Bearer ${token.access_token}`;
		config.headers.Accept = 'application/json';
	}

	// mApp.blockPage({
    //     overlayColor: '#000000',
    //     type: 'loader',
    //     state: 'primary',
    //     message: 'Đang xử lý...'
    // });

 	return config;

}, function(err) {
  	return Promise.reject(err);
});

window.axios.interceptors.response.use(function (response) {
    // mApp.unblockPage();
    
	if(response.data.code < 0){
		if(typeof response.data.msg === 'string'){
			swal("Lỗi", response.data.msg, "error");
			return new Promise(() => {});
		}
		return response;
	}

    return response;

}, function (error) {
	const { response: { status } } = error;
	// mApp.unblockPage();

  	if(status == 401){
  		let mess = error.response.data.msg && error.response.data.data == null ? error.response.data.msg : "Bạn không có quyền thực hiện hành động này!"
		  localStorage.clear();
      router.replace({ name: 'LoginPage', params: { "message": mess } });

  		return Promise.reject(error);
  	}

  	if(status == 422){
  		let errors = error.response.data.errors;
  		let keys = Object.keys(errors);

  		for(let i=0;i<keys.length;i++){
  			toastr.error( errors[keys[i]] );
  		}

  		return Promise.reject(error);
  	}

  	if(status == 500){
  		let errors = error.response.data.errors;
  		// let keys = Object.keys(errors);

  		// for(let i=0;i<keys.length;i++){
  		// 	toastr.error( errors[keys[i]] );
  		// }

  		return Promise.reject(error);
  	}

    return Promise.reject(error);
});

import {initAuthManager} from './authManager';
initAuthManager(router);

$.fn.datepicker.dates['vi-VN'] = {
	applyLabel: "Chọn",
	cancelLabel: "Xóa",
	customRangeLabel: "Chọn ngày",
    days: ["Chủ nhật", "Thứ hai", "Thứ ba", "Thứ tư", "Thứ năm", "Thứ sáu", "Thứ bảy"],
    daysShort: ["CN", "Hai", "Ba", "Tư", "Năm", "Sáu", "Bảy"],
    daysMin: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
    months: ["Tháng một", "Tháng hai", "Tháng ba", "Tháng tư", "Tháng năm", "Tháng sáu", "Tháng bảy", "Tháng tám", "Tháng chín", "Tháng mười", "Tháng mười một", "Tháng mười hai"],
    monthsShort: ["Một", "Hai", "Ba", "Bốn", "Năm", "Sáu", "Bảy", "Tám", "Chín", "Mười", "Mười một", "Mười hai"],
    today: "Hôm nay",
    clear: "Xóa",
    format: "dd/mm/yyyy",
    titleFormat: "MM yyyy", /* Leverages same syntax as 'format' */
	weekStart: 0
};

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
